import { axiosInstance as axios } from "./axios.config";

const LEGAL_DOCUMENTS_API = import.meta.env.VITE_LEGAL_DOCUMENTS_API_URL

export interface DocumentHash {
  hash: string;
  document_type: string;
}

export interface LegalDocument {
  id: number;
  document_type_code: string;
  document_type_name: string;
  version: number;
  version_display: string;
  file: string;
  file_url: string;
  file_hash: string;
  is_active: boolean;
  created_at: string;
}

export interface LatestDocumentsResponse {
  origin: string;
  documents: LegalDocument[];
}

export interface SignDocumentsPayload {
  email: string;
  document_hashes: string[];
  origin: string;
  pedido_id: string | number;
}

export interface DocumentStatus {
  code: string;
  name: string;
  signed: boolean;
  already_signed: boolean;
  version: number;
}

export interface CheckSignatureResponse {
  origin: string;
  all_signed: boolean;
  documents: DocumentStatus[];
}

export const getLatestDocuments = async (origin: string): Promise<LatestDocumentsResponse> => {
  const url = `${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/latest/?origin=${origin}`;
  const response = await axios.get(url);
  return response.data;
};

export const checkSignature = async (userId: string | number, origin: string): Promise<CheckSignatureResponse> => {
  const url = `${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/check-signature/?user_id=${userId}&origin=${origin}`;
  const response = await axios.get(url);
  return response.data;
};

export const signDocuments = async (payload: SignDocumentsPayload) => {
  const url = `${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/sign/`;
  return await axios.post(url, payload);
};
